import R from '../assets/Images/Quote/Hero-Section.jpg';


const blogMeta = [
    {
      image: R,
      id: 'blog-1',
      title: 'Top AI Tools in 2026: Best Artificial Intelligence Software for Business and Creators',
      description: 'Discover the top AI tools in 2026 that are transforming content creation, automation, design, coding, and business productivity. A complete expert guide.',
    },
    {
      image: R,
      id: 'blog-2',
      title: 'Title 2',
      description: 'Discover the top AI tools in 2026 that are transforming content creation, automation, design, coding, and business productivity. A complete expert guide.',
    },
    {
      image: R,
      id: 'blog-3',
      title: 'Title 3',
      description: 'Discover the top AI tools in 2026 that are transforming content creation, automation, design, coding, and business productivity. A complete expert guide.',
    },
    {
      image: R,
      id: 'blog-4',
      title: 'Title 4',
      description: 'Discover the top AI tools in 2026 that are transforming content creation, automation, design, coding, and business productivity. A complete expert guide.',
    },
  ];
  
  export default blogMeta;